<footer class="nga-footer mt-5">
  <hr>
  <div class="container py-2">
    <div class="row align-items-center pt-3">
      <div class="col-lg-12 col-md-12 col-sm-12 text-center">
        <p class="mb-0">
          <b>PT Bolttech Insurance Broker</b> berizin dan diawasi oleh Otoritas Jasa 
          Keuangan. 
        </p>
      </div>
    </div>
  </div>
</footer>
